"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VIEW_ONLINE_URL = exports.HAS_PDF = exports.GROUP_TITLE = exports.GROUP_EXPANDED_SUMBOL = exports.GROUPED_NONE = exports.GROUPED_BY_TYPE = exports.GROUPED_BY_COLLECTION = exports.FORMATTED_DATE_SYMBOL = exports.CHILD_OTHER = exports.CHILD_NOTES = exports.CHILD_ATTACHMENTS = exports.AUTHORS_SYMBOL = exports.ABSTRACT_NOTE_PROCESSED = void 0;

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

var GROUPED_NONE = 0;
exports.GROUPED_NONE = GROUPED_NONE;
var GROUPED_BY_TYPE = 1;
exports.GROUPED_BY_TYPE = GROUPED_BY_TYPE;
var GROUPED_BY_COLLECTION = 2;
exports.GROUPED_BY_COLLECTION = GROUPED_BY_COLLECTION;
var CHILD_NOTES = Symbol.for('childNotes');
exports.CHILD_NOTES = CHILD_NOTES;
var CHILD_ATTACHMENTS = Symbol.for('childAttachments');
exports.CHILD_ATTACHMENTS = CHILD_ATTACHMENTS;
var CHILD_OTHER = Symbol.for('childOther');
exports.CHILD_OTHER = CHILD_OTHER;
var GROUP_EXPANDED_SUMBOL = Symbol.for('groupExpanded');
exports.GROUP_EXPANDED_SUMBOL = GROUP_EXPANDED_SUMBOL;
var GROUP_TITLE = Symbol.for('groupTitle');
exports.GROUP_TITLE = GROUP_TITLE;
var VIEW_ONLINE_URL = Symbol.for('viewOnlineUrl');
exports.VIEW_ONLINE_URL = VIEW_ONLINE_URL;
var ABSTRACT_NOTE_PROCESSED = Symbol.for('abstractNoteProcessed');
exports.ABSTRACT_NOTE_PROCESSED = ABSTRACT_NOTE_PROCESSED;
var AUTHORS_SYMBOL = Symbol.for('authors');
exports.AUTHORS_SYMBOL = AUTHORS_SYMBOL;
var FORMATTED_DATE_SYMBOL = Symbol.for('formattedDate');
exports.FORMATTED_DATE_SYMBOL = FORMATTED_DATE_SYMBOL;
var HAS_PDF = Symbol.for('hasPdf');
exports.HAS_PDF = HAS_PDF;
var _default = {
  GROUPED_NONE: GROUPED_NONE,
  GROUPED_BY_TYPE: GROUPED_BY_TYPE,
  GROUPED_BY_COLLECTION: GROUPED_BY_COLLECTION,
  CHILD_NOTES: CHILD_NOTES,
  CHILD_ATTACHMENTS: CHILD_ATTACHMENTS,
  CHILD_OTHER: CHILD_OTHER,
  GROUP_EXPANDED_SUMBOL: GROUP_EXPANDED_SUMBOL,
  GROUP_TITLE: GROUP_TITLE,
  VIEW_ONLINE_URL: VIEW_ONLINE_URL,
  ABSTRACT_NOTE_PROCESSED: ABSTRACT_NOTE_PROCESSED,
  AUTHORS_SYMBOL: AUTHORS_SYMBOL,
  FORMATTED_DATE_SYMBOL: FORMATTED_DATE_SYMBOL,
  HAS_PDF: HAS_PDF
};
exports.default = _default;